// extracted by mini-css-extract-plugin
export default {"color":"pPk9qmX7","swatch":"yCk0ionQ"};